import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ButtonType, ButtonVariant, DateTimeFormat, IconName, PopoverPosition } from '@yupma/ui-kit';

@Component({
  selector: 'app-date-and-time-picker-input',
  templateUrl: './date-and-time-picker-input.component.html',
  styleUrl: './date-and-time-picker-input.component.scss'
})
export class DateAndTimePickerInputComponent implements OnInit, OnChanges {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() value: number = 0;//1730754005205
  @Input() required: boolean = false;
  @Input() hideOptional: boolean = false;
  @Input() error: boolean = false;
  @Input() disabled: boolean = false;
  @Input() inlineInfo: string = '';
  @Input() errorText: string = 'This field is required.';
  @Input() showLabel: boolean = true;
  @Output() valueChange = new EventEmitter<number>();

  iconNames = IconName;
  buttonVariants = ButtonVariant;
  popoverPositions = PopoverPosition;
  buttonTypes = ButtonType;
  isDropdownOpen: boolean = false;
  dateValue: Date | null = null;
  popupDateValue: Date | null = null;
  dateTimeFormats = DateTimeFormat;

  toggleDropdown(state: boolean) {
    this.isDropdownOpen = state;
    if (this.dateValue) {
      this.popupDateValue = new Date(this.dateValue);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes['value']) {
      this.convertValueToDate()
    }
  }

  ngOnInit() {
    this.convertValueToDate()
  }

  convertValueToDate() {
    if (this.value) {
      this.dateValue = new Date(Number(this.value));
    }
  }

  updateDateValue(value: Date) {
    if (!this.popupDateValue) {
      this.popupDateValue = value;
    }
    this.popupDateValue?.setFullYear(value.getFullYear(), value.getMonth(), value.getDate());
  }

  updateTimeValue(value: Date) {
    if (!this.popupDateValue) {
      this.popupDateValue = value;
    }
    this.popupDateValue?.setHours(value.getHours());
    this.popupDateValue?.setMinutes(value.getMinutes());
    this.popupDateValue?.setSeconds(0);
  }

  clearField() {
    this.popupDateValue = null;
  }

  cancelPopup() {
    this.toggleDropdown(false)
  }

  savePopup() {
    this.isDropdownOpen = false;
    if (this.popupDateValue) {
      this.dateValue = new Date(this.popupDateValue);
      this.value = this.dateValue.getTime();
      this.valueChange.emit(this.value);
    } else {
      this.dateValue = null;
      this.value = 0;
      this.valueChange.emit(this.value);
    }
  }
}
